module.exports = __webpack_public_path__ + "img/icon01-01.e5824231.svg";